<script lang="ts">
    import { Button } from "sveltestrap";
    import { dangerButton, InfoButton, LightButton, OutlineLaragebuttons, OutlineLaragebuttonsMessage, PrimaryButton, SecondaryButton, SuccessButton, WarningButton } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
  
</script>
<Card headerTitle={OutlineLaragebuttons} cardHeaderprops="pb-0" cardBodyprops="btn-showcase">
    <div slot="customheader" >
        <span>{@html OutlineLaragebuttonsMessage}</span>
    </div>
    <div slot="contentbody">
        <Button outline color="primary" size="lg">{PrimaryButton}</Button>
        <Button outline color="secondary" size="lg">{SecondaryButton}</Button>
        <Button outline color="success" size="lg">{SuccessButton}</Button>
        <Button outline color="info" size="lg">{InfoButton}</Button>
        <Button outline color="warning" size="lg">{WarningButton}</Button>
        <Button outline color="danger" size="lg">{dangerButton}</Button>
        <Button outline color="light" size="lg">{LightButton}</Button>
    </div>
</Card>
